import isEmpty from 'lodash/isEmpty';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBookIssuesOrders } from 'api/tickets/chegg';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import { setSelectedCheggBookIssuesOrder } from 'actions/tools/OrdersSearchActions';
import LoadingComponent, { LoadingWrapper } from 'components/LoadingComponent/LoadingComponent';
import { getSimplrAccountIdOfSelectedTicket, getSelectedOrderFromOrdersSearch } from 'extractFromState';
import { returnToPreviousMacroWizardPath } from 'actions/searchActions';

const DTValidateCheggBookIssuesNode = () => {
  const dispatch = useDispatch();
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const selectedOrder = useSelector(getSelectedOrderFromOrdersSearch);

  const [isLoading, setIsLoading] = useState(true);
  const [bookIssuesOrders, setBookIssuesOrders] = useState([]);

  const validateSelectedBookIssuesOrder = useCallback(() => {
    for (const bookOrder of bookIssuesOrders) {
      if (bookOrder.id === selectedOrder.orderId) {
        dispatch(setSelectedCheggBookIssuesOrder(bookOrder));

        return dispatch(addEdgeToDecisionTreePath('valid_order'));
      }
    }

    return dispatch(addEdgeToDecisionTreePath('invalid_order'));
  }, [dispatch, selectedOrder, bookIssuesOrders]);

  useEffect(() => {
    (async () => {
      try {
        const bookOrdersFromChegg = await getBookIssuesOrders(simplrAccountId, selectedOrder.customerEmail);
        setBookIssuesOrders(bookOrdersFromChegg);
        setIsLoading(false);
      } catch (error) {
        dispatch(returnToPreviousMacroWizardPath());
      }
    })();
  }, [dispatch, simplrAccountId, selectedOrder]);

  useEffect(() => {
    if (!isLoading) {
      if (!isEmpty(bookIssuesOrders)) {
        validateSelectedBookIssuesOrder();
      } else {
        dispatch(addEdgeToDecisionTreePath('invalid_order'));
      }
    }
  }, [dispatch, bookIssuesOrders, isLoading, validateSelectedBookIssuesOrder]);

  return (
    <LoadingWrapper>
      <LoadingComponent />
    </LoadingWrapper>
  );
};

export default DTValidateCheggBookIssuesNode;
